import { css } from '@emotion/css';

export const styles = {
  benefitIcon: css`
    border-radius: var(--border-radius-rounded);
    background-color: #fde7d8; // Color matches Cosma Tag Indicator, color red

    svg {
      display: block;
      width: 24px;
      height: 24px;
    }
  `,
  benefitText: css`
    hyphens: auto;
    overflow-wrap: anywhere;
  `,
};

export default styles;
